import { createReducer } from '@common/redux-utils';
import { CustomerViewModel } from '@models/Customer';

import {
  ClearCustomerAction,
  CustomerPickerActionType,
  GetCustomerFailureAction,
  GetCustomerStartAction,
  GetCustomerSuccessAction
} from './customer-picker.actions';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface CustomerPickerState {
  customer?: CustomerViewModel;
}

// This is the initial state of the page
const initialState: CustomerPickerState = {};

function handleClearCustomer(state: CustomerPickerState, action: ClearCustomerAction): CustomerPickerState {
  action.customerEmitter(undefined);
  return {
    ...state,
    customer: undefined
  };
}

function handleGetCustomerFailure(state: CustomerPickerState, action: GetCustomerFailureAction): CustomerPickerState {
  return state;
}

function handleGetCustomerStart(state: CustomerPickerState, action: GetCustomerStartAction): CustomerPickerState {
  return state;
}

function handleGetCustomerSuccess(state: CustomerPickerState, action: GetCustomerSuccessAction): CustomerPickerState {
  action.customerEmitter(action.customer);
  return {
    ...state,
    customer: action.customer
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const CustomerPickerReducer = createReducer(initialState, {
  [CustomerPickerActionType.ClearCustomer]: handleClearCustomer,
  [CustomerPickerActionType.GetCustomerFailure]: handleGetCustomerFailure,
  [CustomerPickerActionType.GetCustomerStart]: handleGetCustomerStart,
  [CustomerPickerActionType.GetCustomerSuccess]: handleGetCustomerSuccess
});



// WEBPACK FOOTER //
// ./src/customer/_components/customer-picker/customer-picker.reducer.ts